import styled from "styled-components";
import { Modal } from "react-bootstrap";        
import { colors } from "../../../libs";

export const EmbedModalContainer = styled(Modal)`
    .modal-width {
        max-width: 40%;
    }
    &::-webkit-scrollbar {
        display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    .modal-content {
        background-color: ${colors.background.lightBlack};
        color: ${colors.text.white};
        border: none;
    }

    .btn-close {
        filter: invert(100%);
    }
`;

export const EmbedModalHeader = styled(Modal.Header)`
    border-bottom: none;
`;

export const HolderContainer = styled.div<{ collapsed?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    width: 100%;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease, border-color 0.3s ease;
    ${(props) => props.collapsed ? `
        max-height: 0;
        padding: 0 20px;
        border: 1px solid transparent;
    ` : `
        max-height: 2000px;
        padding: 20px;
        border: 1px solid ${colors.background.grey};
    `}
`;

export const CollapsibleContent = styled.div<{ collapsed?: boolean }>`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    overflow: hidden;
    transition: max-height 0.3s ease, opacity 0.3s ease;
    ${(props) => props.collapsed ? `
        max-height: 0;
        opacity: 0;
    ` : `
        max-height: 2000px;
        opacity: 1;
    `}
`;

export const HolderHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const HolderTitle = styled.span`
    color: ${colors.text.white};
    font-size: 18px;
`;

export const Spacer = styled.div`
    height: 20px;
`;

export const LinkRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    gap: 8px;
`;

export const LinkInput = styled.input`
    flex: 1;
    background-color: ${colors.background.grey};
    color: ${colors.text.green};
    border: 1px solid ${colors.background.grey};
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    outline: none;
    cursor: default;
    opacity: 0.8;
`;

export const IframeTextArea = styled.textarea`
    flex: 1;
    background-color: ${colors.background.grey};
    color: ${colors.text.green};
    border: 1px solid ${colors.background.grey};
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    outline: none;
    cursor: default;
    opacity: 0.8;
    resize: none;
    font-family: inherit;
`;

export const CopyButton = styled.button`
    background-color: transparent;
    color: ${colors.text.green};
    border: 1px solid ${colors.background.green};
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    &:hover {
        background-color: ${colors.background.grey};
    }
`;

export const TextInput = styled.input`
    width: 100%;
    background-color: ${colors.background.grey};
    color: ${colors.text.white};
    border: 1px solid ${colors.background.grey};
    border-radius: 6px;
    padding: 8px 12px;
    font-size: 14px;
    outline: none;
    &::placeholder {
        color: rgba(255, 255, 255, 0.4);
    }
`;

export const SlugInputRow = styled.div`
    width: 100%;
`;

export const SlugActionRow = styled.div`
    display: flex;
    flex-direction: row;
    gap: 8px;
    width: 100%;
`;

export const SaveSlugButton = styled.button`
    background-color: transparent;
    color: ${colors.text.green};
    border: 1px solid ${colors.background.green};
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        background-color: ${colors.background.grey};
    }
`;

export const CancelButton = styled.button`
    background-color: transparent;
    color: rgba(255, 255, 255, 0.5);
    border: 1px solid ${colors.background.green};
    border-radius: 6px;
    padding: 8px 14px;
    font-size: 14px;
    cursor: pointer;
    &:hover {
        color: ${colors.text.white};
    }
`;

export const SlugDisplayRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
`;

export const SlugText = styled.span`
    color: ${colors.text.white};
    font-size: 14px;
`;

export const EditButton = styled.button`
    background-color: transparent;
    color: ${colors.text.white};
    border: 1px solid ${colors.background.grey};
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 13px;
    cursor: pointer;
    &:hover {
        background-color: ${colors.background.grey};
    }
`;